import Utility from "../../../shared/utility.js";
import EncryptUtility from "../../utility/js/encrypt-utility.js";
import AddFavourite from "../../utility/js/addFav.js";
import breadcrumbComp from "../../common/breadcrumb-comp";
import commonApiService from "../../common/js/common-api-service.js";
import usbService from "../js/usb-services.js";
import PrinterDetails from "../../common/printer-details";
export default {
  data() {
    return {
      refresh: true,
      backSlash: true,
      actionList: [],
      mainPage: "",
      subPage: "",
      pageUrl: "",
      favouriteList: [],
      showAdd: false,
      userId: EncryptUtility.localStorageDecrypt("userID"),
      labelsOn: true,
      unitIdentifierValid: false,
      searchUnit: "",
      searchUnitDisable: false,
      testPassComments: "",
      testFailComments: "",
      passFlow: false,
      failFlow: false,
      symptom: "",
      symptomList: [],
      failureCode: "",
      failureCodeList: [],
      failureMode: "",
      failureModeList: [],
      unitSearchResult: [],
      searchDetails: false,
      passFailValid: false,
      panel: 0,
      stagingLocation: EncryptUtility.localStorageDecrypt("StagingLocation"),
      lpn: EncryptUtility.localStorageDecrypt("LPNNumber"),
      showLastTransaction: false,
      lastTransaction: [],
      hideFail: true,
      hidePass: true,
      selfTestPassFail: false,
      showPrimary: true,
      printerConfigured: false,
      disableLabelsOn: false,
      required: [(v) => !!v || "Field is required"],
      max50Rule: [(v) => (v || "").length <= 50 || "Max Length of 50 character", (v) => !!v || "Field is required"],
      LPNRule: [
        (v) => (v || "").length <= 39 || "Max Length of 39 characters",
        (v) => !!v || "Field is required",
        (value) => /^[0-9]{1,3}(?:-[0-9]{3})*$/.test(value) || "Enter a correct format: 000-000-000-000",
      ],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.primaryName = EncryptUtility.localStorageDecrypt("primaryName");
    this.primaryLabelSize = EncryptUtility.localStorageDecrypt("primaryLabelSize");
    this.primaryPrinterType = EncryptUtility.localStorageDecrypt("primaryPrinterType");
    if(EncryptUtility.localStorageDecrypt("LabelSwitchValue") !== null && EncryptUtility.localStorageDecrypt("LabelSwitchValue") !== undefined){
      this.labelsOn = JSON.parse(EncryptUtility.localStorageDecrypt("LabelSwitchValue"));
      this.labelValue = this.labelsOn;
    }
    this.onChangeLabelFunction(this.labelsOn);
    if (this.labelsOn) {
      if (EncryptUtility.localStorageDecrypt("primaryLabelSize") !== null && EncryptUtility.localStorageDecrypt("primaryLabelSize") !== undefined) {
        this.searchUnitDisable = false;
        this.printerConfigured = false;
      } else {
        this.searchUnitDisable = true;
        this.printerConfigured = true;
        let Alert = {
          type: "error",
          isShow: true,
          message: "Receiving/Inventory Printer is not configured, please configure printer",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.$refs.unitIdentifierForm.resetValidation();
      }
    }
  },
  methods: {
    //Reset Function
    resetFunction() {
      this.searchUnit = "";
      this.searchUnitDisable = false;
      this.disableLabelsOn = false;
      this.testPassComments = "";
      this.testFailComments = "";
      this.passFlow = false;
      this.failFlow = false;
      this.symptom = "";
      this.symptomList = [];
      this.failureCode = "";
      this.failureCodeList = [];
      this.failureMode = "";
      this.failureModeList = [];
      this.unitSearchResult = [];
      this.searchDetails = false;
      this.panel = 0;
      this.hideFail = true;
      this.hidePass = true;
      this.selfTestPassFail = false;
      this.$refs.unitIdentifierForm.resetValidation();
    },
    //Unit Identifier
    async searchUnitIdentifier() {
      if (this.$refs.unitIdentifierForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        let obj = {
          pass: 1,
          user_id: parseInt(this.userId),
          unit: this.searchUnit,
          proj_id: 0,
          main_key: 0,
          bin: "",
          lpn: "",
          selftest: false,
          results: 0,
          failc_key: 0,
          failtype_key: 0,
          symptom_key: 0,
          flexstring: "",
          comments: "",
          lbl_size: "",
          printer_type: "",
        };
        this.axios
          .post("wc/initial_test", obj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let data = JSON.parse(response.data.body.message);
              this.unitSearchResult = data;
              this.searchDetails = true;
              this.searchUnitDisable = true;
              this.showLastTransaction = false;
              this.lastTransaction = [];
              this.disableLabelsOn = false;
              this.getFailureDropdowns();
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          });
      }
    },
    //Input at Staging Location
    inputStagingLocation() {
      this.stagingLocation = this.stagingLocation?.toUpperCase();
      EncryptUtility.localStorageEncrypt("StagingLocation", this.stagingLocation);
    },
    //Submit Test Results
    submitTestResults() {
      if (this.$refs.passFailForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        let obj = {
          pass: 7,
          user_id: parseInt(this.userId),
          unit: this.searchUnit,
          proj_id: parseInt(this.unitSearchResult?.Result[0]?.project_id),
          main_key: parseInt(this.unitSearchResult?.Result[0]?.main_key),
          bin: this.stagingLocation,
          lpn: this.lpn,
          selftest: this.selfTestPassFail,
          results: this.passFlow == true ? 1 : 0,
          failc_key: this.failureCode !== "" ? parseInt(this.failureCode) : 0,
          failtype_key: this.failureMode !== "" ? parseInt(this.failureMode) : 0,
          symptom_key: this.symptom !== "" ? parseInt(this.symptom) : 0,
          flexstring: "", //not known
          comments: this.failFlow ? this.testFailComments : this.testPassComments,
          lbl_size: EncryptUtility.localStorageDecrypt("primaryLabelSize"),
          printer_type: EncryptUtility.localStorageDecrypt("primaryPrinterType"),
        };
        this.axios
          .post("wc/initial_test", obj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let data = JSON.parse(response.data.body.message);
              EncryptUtility.localStorageEncrypt("LPNNumber", this.lpn);
              this.resetFunction();
              this.showLastTransaction = true;
              if (data[0]?.message !== null && data[0]?.message != undefined && data[0]?.message != "") {
                this.lastTransaction = data[0]?.message;
              }
              if (data[0]?.label !== null && data[0]?.label != undefined && data[0]?.label != "") {
                this.labelsOn ? PrinterDetails.printLabelData(data[0]?.label, EncryptUtility.localStorageDecrypt("primaryName")) : "";
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          });
      }
    },
    // Failure Dropdowns
    async getFailureDropdowns() {
      let obj = {
        pass: 3,
        user_id: parseInt(this.userId),
        unit: this.searchUnit,
        proj_id: 0,
        main_key: parseInt(this.unitSearchResult?.Result[0]?.main_key),
        stage_bin_key: 0,
        lpn: "",
        selftest: false,
        results: 0,
        failc_key: 0,
        failtype_key: 0,
        symptom_key: 0,
        flexstring: "",
        comments: "",
        lbl_size: "",
        printer_type: "",
      };
      let data = await usbService.workcenterInitialTest("post", obj);
      if (data.message !== "NA") {
        this.failureCodeList = data.failcodeList;
        this.symptomList = data.symptomList;
        this.failureModeList = data.failmodelist;
      }
    },
    //Test pass button click
    testPass() {
      this.passFlow = true;
      this.failFlow = false;
      this.testPassComments = "";
      this.testFailComments = "";
      this.symptom = "";
      this.failureCode = "";
      this.failureMode = "";
      this.hidePass = false;
      this.hideFail = true;
    },
    //Test Fail button click
    testFail() {
      this.passFlow = false;
      this.failFlow = true;
      this.testPassComments = "";
      this.testFailComments = "";
      this.symptom = "";
      this.failureCode = "";
      this.failureMode = "";
      this.hidePass = true;
      this.hideFail = false;
    },
    //LPN Number Format
    lpnNumFormat(event, num) {
      this.lpn = Utility.formatLPNNumber(event, num);
      EncryptUtility.localStorageEncrypt("LPNNumber", this.lpn);
    },
    //Get LPN Number
    async getLPNNumber() {
      let lpnData = await commonApiService.getNextAvailableLPN("get", this.userId);
      if (lpnData.message !== "NA") {
        this.lpn = lpnData[0]?.lpn;
        EncryptUtility.localStorageEncrypt("LPNNumber", this.lpn);
      }
    },
    //To capture printer details once saved
    printerDetails(labelPrinter) {
      if (!labelPrinter) {
        this.searchUnitDisable = false;
        this.printerConfigured = false;
        this.$refs.unitIdentifierForm.resetValidation();
      } else {
        this.searchUnitDisable = true;
        this.printerConfigured = true;
      }
    },
    //Label change function
    onChangeLabelFunction(val) {
      this.labelValue = val;
      this.labelsOn = val;
      if (!this.labelsOn) {
        this.searchUnitDisable = false;
      }
      EncryptUtility.localStorageEncrypt("LabelSwitchValue", JSON.stringify(this.labelsOn));
    },
    //To add or remove Favourite issue
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
    PrinterDetails,
  },
};
